/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIAddress
 */
export interface APIAddress {
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIAddress
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIAddress
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    address1: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    address3?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddress
     */
    info?: string;
}

/**
 * Check if a given object implements the APIAddress interface.
 */
export function instanceOfAPIAddress(value: object): value is APIAddress {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('address1' in value) || value['address1'] === undefined) return false;
    return true;
}

export function APIAddressFromJSON(json: any): APIAddress {
    return APIAddressFromJSONTyped(json, false);
}

export function APIAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'address1': json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'address3': json['address_3'] == null ? undefined : json['address_3'],
        'zipCode': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function APIAddressToJSON(value?: Omit<APIAddress, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address_1': value['address1'],
        'address_2': value['address2'],
        'address_3': value['address3'],
        'zip_code': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'info': value['info'],
    };
}

